import { NavLink, useLoaderData } from "react-router-dom";
import PageTitle from "../ui/PageTitle";

const ConversationList = () => {
  const { conversations } = useLoaderData();

  return (
    <>
      <div className="page-div">
        <div className="title-area w-full">
          <PageTitle
            title="Conversations"
            breadcrumb={[
              { name: "home", path: "/" },
              { name: "Conversations", path: "/conversation" },
            ]}
          />
        </div>
        <div className="flex">
          <div className="datatable">
            <table>
              <tbody>
                {conversations.map((conversation) => (
                  <tr key={conversation.conversationEntityId}>
                    <td
                      valign="top"
                      style={{ textAlign: "center", verticalAlign: "top" }}
                      className="my-1.5"
                    >
                      <img
                        src={`${process.env.PUBLIC_URL}/assets/images/img1.png`}
                        alt="conImage"
                      />
                    </td>
                    <td valign="top" style={{ verticalAlign: "top" }}>
                      <NavLink to={`./${conversation.conversationEntityId}`}>
                        <h3 className="text-[18px] font-medium text-qblack mb-1.5 ml-4">
                          {conversation.label}
                        </h3>
                      </NavLink>

                      <ul>
                        <li>
                          {conversation.shortDescription && (
                            <p className="text-[15px] text-qgraytwo leading-7 mb-2.5 ml-4">
                              {conversation.shortDescription}
                            </p>
                          )}
                        </li>
                      </ul>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default ConversationList;


